export default __webpack_public_path__ + "static/media/voted_icon.95426006.svg";